import { TiptapJSON } from '../types/template.types';

/**
 * Greek Medical Genetics Laboratory Header Template
 * 3-column layout with laboratory name, national emblem, and research institute
 * This header is non-editable (editable: false)
 */
export const greekMedicalGeneticsHeader: TiptapJSON = {
  type: 'div',
  attrs: {
    style:
      'display: flex; flex-direction: row; justify-content: space-between; align-items: stretch; border: 2px solid #000; padding: 10px; margin-bottom: 20px; background-color: #fff; font-size: 8pt;',
    editable: false,
    sectionId: 'header',
    sectionType: 'header',
  },
  content: [
    // Left column - Laboratory Name
    {
      type: 'div',
      attrs: {
        style:
          'flex: 1; border-right: 1px solid #000; padding-right: 12px; display: flex; flex-direction: column; justify-content: center;',
        editable: false,
      },
      content: [
        {
          type: 'paragraph',
          attrs: { textAlign: 'center' },
          content: [
            {
              type: 'text',
              marks: [{ type: 'bold' }],
              text: 'ΕΡΓΑΣΤΗΡΙΟ ΙΑΤΡΙΚΗΣ ΓΕΝΕΤΙΚΗΣ',
            },
            { type: 'hardBreak' },
            {
              type: 'text',
              marks: [{ type: 'bold' }],
              text: 'ΕΞΕΙΔΙΚΕΥΜΕΝΟ ΔΙΑΓΝΩΣΤΙΚΟ ΕΡΓΑΣΤΗΡΙΟ',
            },
            { type: 'hardBreak' },
            {
              type: 'text',
              marks: [{ type: 'bold' }],
              text: 'ΑΝΑΛΥΣΗΣ ΓΕΝΕΤΙΚΩΝ ΝΟΣΗΜΑΤΩΝ',
            },
          ],
        },
      ],
    },
    // Center column - National Emblem and University
    {
      type: 'div',
      attrs: {
        style:
          'flex: 1; border-right: 1px solid #000; padding: 0 12px; display: flex; flex-direction: column; justify-content: center;',
        editable: false,
      },
      content: [
        {
          type: 'paragraph',
          attrs: { textAlign: 'center' },
          content: [
            {
              type: 'text',
              marks: [{ type: 'bold' }],
              text: 'ΕΛΛΗΝΙΚΗ ΔΗΜΟΚΡΑΤΙΑ',
            },
            { type: 'hardBreak' },
            {
              type: 'text',
              marks: [{ type: 'bold' }],
              text: 'Εθνικόν και Καποδιστριακόν',
            },
            { type: 'hardBreak' },
            {
              type: 'text',
              marks: [{ type: 'bold' }],
              text: 'Πανεπιστήμιον Αθηνών',
            },
          ],
        },
      ],
    },
    // Right column - Research Institute
    {
      type: 'div',
      attrs: {
        style:
          'flex: 1; padding-left: 12px; display: flex; flex-direction: column; justify-content: center;',
        editable: false,
      },
      content: [
        {
          type: 'paragraph',
          attrs: { textAlign: 'center' },
          content: [
            {
              type: 'text',
              marks: [{ type: 'bold' }],
              text: 'ΕΡΕΥΝΗΤΙΚΟ ΠΑΝΕΠΙΣΤΗΜΙΑΚΟ',
            },
            { type: 'hardBreak' },
            {
              type: 'text',
              marks: [{ type: 'bold' }],
              text: 'ΙΝΣΤΙΤΟΥΤΟ ΜΕΛΕΤΗΣ ΚΑΙ',
            },
            { type: 'hardBreak' },
            {
              type: 'text',
              marks: [{ type: 'bold' }],
              text: 'ΑΝΤΙΜΕΤΩΠΙΣΗΣ ΓΕΝΕΤΙΚΩΝ ΚΑΙ',
            },
            { type: 'hardBreak' },
            {
              type: 'text',
              marks: [{ type: 'bold' }],
              text: 'ΚΑΚΟΗΘΩΝ ΝΟΣΗΜΑΤΩΝ',
            },
            { type: 'hardBreak' },
            {
              type: 'text',
              marks: [{ type: 'bold' }],
              text: 'ΤΗΣ ΠΑΙΔΙΚΗΣ ΗΛΙΚΙΑΣ',
            },
          ],
        },
      ],
    },
  ],
};

/**
 * Standard footer template with laboratory contact information
 */
export const standardFooter: TiptapJSON = {
  type: 'div',
  attrs: {
    style:
      'border-top: 1px solid #ccc; padding-top: 16px; margin-top: 24px; font-size: 10px; color: #666;',
    editable: false,
    sectionId: 'footer',
    sectionType: 'footer',
  },
  content: [
    {
      type: 'paragraph',
      attrs: { textAlign: 'center' },
      content: [
        {
          type: 'text',
          text: 'Εργαστήριο Ιατρικής Γενετικής - Νοσοκομείο Παίδων «Αγία Σοφία»',
        },
      ],
    },
    {
      type: 'paragraph',
      attrs: { textAlign: 'center' },
      content: [
        {
          type: 'text',
          text: 'Θηβών & Λεβαδείας, 115 27 Γουδή, Αθήνα | Τηλ: 210-7467462 | Email: medgen@med.uoa.gr',
        },
      ],
    },
  ],
};
